// extracted by mini-css-extract-plugin
module.exports = {"orderProductsCard":"OrderProductsCard_orderProductsCard__mXP5S","smallGrid":"OrderProductsCard_smallGrid__UXK06","regularGrid":"OrderProductsCard_regularGrid__p_8v9"};